var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6719 8.8273C17.6714 9.12341 17.5619 9.40719 17.3673 9.61622L10.6105 16.8767C10.2054 17.312 9.5497 17.3108 9.14596 16.8741C8.74222 16.4373 8.74332 15.7304 9.1484 15.2951L14.1335 9.93848L1.03415 9.91804C0.462219 9.91715 -0.000749982 9.41657 7.97415e-05 8.79996C0.000907558 8.18336 0.465219 7.68422 1.03715 7.68511L14.1389 7.70556L9.14597 2.30463C8.74223 1.8679 8.74332 1.161 9.1484 0.725717C9.55349 0.290437 10.2092 0.291612 10.6129 0.728342L17.3698 8.0373C17.5637 8.24702 17.6723 8.5312 17.6719 8.8273Z",
    fill: "#061556"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleArrow);
export default __webpack_public_path__ + "static/media/single-arrow.708b559a353ac147b3cbcf407ecaee87.svg";
export { ForwardRef as ReactComponent };